import Reveal from '../components/Reveal';
import { COMPANY } from '../data';

export default function Privacy() {
  return (
    <div style={{ paddingTop: 90 }}>
      <section className="section">
        <div className="container" style={{ maxWidth: 820 }}>
          <Reveal>
            <span className="tag">Legal</span>
            <h1 style={{ fontFamily: 'var(--fD)', fontSize: 'clamp(28px,4vw,52px)', fontWeight: 900, marginBottom: 16 }}>
              Privacy Policy
            </h1>
            <p style={{ color: 'var(--mut)', fontSize: 15, marginBottom: 48 }}>
              Last updated: January 2025 — {COMPANY.name}
            </p>
          </Reveal>

          {[
            {
              title: '1. Information We Collect',
              body: `When you fill out our enquiry form or contact us, we collect information you voluntarily provide, including your name, phone number, email address, company name, project location, and any goals or messages you share. We may also collect standard web usage data such as browser type, IP address, and pages visited through cookies and analytics tools.`,
            },
            {
              title: '2. How We Use Your Information',
              body: `We use the information you provide to: respond to your enquiries and consultation requests; provide our digital marketing services; communicate with you about your campaigns and results; send service-related updates and notifications. We do not use your information for unrelated marketing without your explicit consent.`,
            },
            {
              title: '3. WhatsApp & Communication',
              body: `When you submit our enquiry form, your details are shared via WhatsApp to enable our team to contact you promptly. By submitting the form, you consent to being contacted via WhatsApp and phone at the number provided. You can opt out of further communication at any time by messaging us directly.`,
            },
            {
              title: '4. Data Sharing',
              body: `We do not sell, rent, or trade your personal information to third parties. We may share your data with trusted service providers who help us operate our business (such as analytics platforms), strictly for that purpose and under confidentiality agreements. We may also disclose information if required by law.`,
            },
            {
              title: '5. Data Retention',
              body: `We retain your personal information only as long as necessary to provide our services or as required by applicable law. You may request deletion of your data at any time by contacting us at ${COMPANY.email}.`,
            },
            {
              title: '6. Cookies',
              body: `Our website may use cookies to enhance your browsing experience and gather analytics data. You can disable cookies in your browser settings, though this may affect certain website functionality.`,
            },
            {
              title: '7. Security',
              body: `We take reasonable measures to protect your personal data against unauthorized access, disclosure, or misuse. However, no data transmission over the internet is 100% secure, and we cannot guarantee absolute security.`,
            },
            {
              title: '8. Your Rights',
              body: `You have the right to access, correct, or delete your personal data held by us. To exercise these rights, please contact us at ${COMPANY.email} or call us at ${COMPANY.phone}.`,
            },
            {
              title: '9. Changes to This Policy',
              body: `We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated date. We encourage you to review this policy periodically.`,
            },
            {
              title: '10. Contact Us',
              body: `If you have any questions about this Privacy Policy, please contact us:\n\nNeural Media Solutions\n${COMPANY.address}\nPhone: ${COMPANY.phone}\nEmail: ${COMPANY.email}`,
            },
          ].map((section, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <div style={{ marginBottom: 40 }}>
                <h2 style={{ fontFamily: 'var(--fD)', fontSize: 22, fontWeight: 700, marginBottom: 12, color: 'var(--txt)' }}>
                  {section.title}
                </h2>
                <p style={{ color: 'var(--mut)', fontSize: 15, lineHeight: 1.85, whiteSpace: 'pre-line' }}>
                  {section.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
